<template>
<div class="page-container" :style="marginTopStyle">
    <div class="columns">
        <div class="column is-1">
            <img width="100px" :src="require('@/assets/img/server.svg')" />
        </div>
        <div class="column is-10">
            <p v-if="!filesMessage" class="default-settings-title">Connect your {{ formattedDatabaseType }} databases</p>
            <p v-if="filesMessage" class="default-settings-title">Connect a server to backup</p>
            <p v-if="!filesMessage" class="default-settings-description">
                You don't have any database added yet. Use the button <b>Add database</b> from above to setup automated backups for your databases.                
            </p>
            <p v-if="filesMessage" class="default-settings-description">
                You don't have any file backups scheduled. Use the button <b>Schedule new backup</b> from above to setup automated backups for your servers files.                
            </p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        marginTop: {
            type: Number,
            default: 0,
        },
        filesMessage: {
            type: Boolean,
            default: false,
        },
        databaseType: {
            type: String,
            default: 'mysql',
        }
    },

    computed: {
        marginTopStyle() {
            return 'margin-top: ' + this.marginTop + 'px !important;';
        },

        formattedDatabaseType() {
            if (this.databaseType == 'mysql') {
                return 'MySQL';
            }

            if (this.databaseType == 'postgresql') {
                return 'PostgreSQL';
            }

            return '';
        },
    },
}
</script>
